/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable react/button-has-type */
import React, { useState } from "react";
import Carousel from "react-elastic-carousel";
import { RootStateOrAny, useSelector } from "react-redux";
import DialogCommon from "components/dialogCommon";
import { AuthState } from "store/ducks/auth/types";
import ModalEspelho from "screens/products/components/modalEspelho";

import { IoVolumeHighOutline } from "react-icons/io5";
import {
  renderCarouselArrow,
  renderCarouselPagination,
} from "utils/elasticCarouselRenderers";
import * as IconsSVG from "../../../../assets/iconsSVG";
import images from "../../../../constants/images";
import * as Styles from "./styles";

import "./carousel.css";

const WantToDoCard: React.FC = () => {
  const user = useSelector<RootStateOrAny, AuthState>((state) => state.user);
  const { idCorretor2013 } = useSelector<RootStateOrAny, AuthState>(
    (state) => state.user
  );
  const [oportunityModal, setOportunityModal] = useState<boolean>(false);
  const breakPoints = [
    { width: 1, itemsToShow: 1 },
    { width: 550, itemsToShow: 3, itemsToScroll: 1 },
    { width: 768, itemsToShow: 3 },
    { width: 900, itemsToShow: 4 },
  ];

  const cargoUser = () => {
    switch (user?.codigoCargo2013) {
      case "219.840.000":
        // Superintendente
        return "superintendente";
      case "219.840.001":
        // GerenteVendas
        return "gerenteVendas";
      case "219.840.002":
        // Corretor
        return "corretor";
      default:
        return "corretor";
    }
  };

  const items = [
    ...(user.usuarioComercial
      ? [
          {
            id: 0,
            title: "Funil Comercial",
            redirecionamento: "/funil-comercial",
            icone: <IconsSVG.FunilPropostasIcon color="#2D5BFF" size="24" />,
            iconTopRight: false,
            regionaisPermitidas: [1, 2, 3, 4, 5, 6, 7, 8],
            usersPermitidos: ["corretor", "gerenteVendas", "superintendente"],
          },
          {
            id: 6,
            title: "Funil de Propostas",
            redirecionamento: "/funil-de-propostas",
            icone: <IconsSVG.FunilPropostasIcon color="#2D5BFF" size="24" />,
            iconTopRight: false,
            regionaisPermitidas: [1, 2, 3, 4, 5, 6, 7, 8],
            usersPermitidos: ["corretor", "gerenteVendas", "superintendente"],
          },
        ]
      : []),
    {
      id: 1,
      title: "Carteira",
      redirecionamento: "/leads",
      icone: <IconsSVG.ShortcutWalletIcon />,
      iconTopRight: false,
      regionaisPermitidas: [1, 2, 3, 4, 5, 6, 7, 8],
      usersPermitidos: ["corretor", "gerenteVendas", "superintendente"],
    },
    {
      id: 2,
      title: "Novo lead",
      redirecionamento: "/leads-novo",
      icone: <IconsSVG.ShortcutUserIcon />,
      iconTopRight: false,
      regionaisPermitidas: [1, 2, 3, 4, 5, 6, 7, 8],
      usersPermitidos: ["corretor"],
    },
    ...(!user.usuarioComercial
      ? [
          {
            id: 6,
            title: "Funil de Propostas",
            redirecionamento: "/funil-de-propostas",
            icone: <IconsSVG.FunilPropostasIcon color="#2D5BFF" size="24" />,
            iconTopRight: false,
            regionaisPermitidas: [1, 2, 3, 4, 5, 6, 7, 8],
            usersPermitidos: ["corretor", "gerenteVendas", "superintendente"],
          },
        ]
      : []),
    {
      id: 4,
      title: "Produtos",
      redirecionamento: "/produtos",
      icone: (
        <IconsSVG.ProductPredio2
          color="#2D5BFF"
          size="32"
          viewBox=" 0 0 14 15"
        />
      ),
      iconTopRight: false,
      regionaisPermitidas: [1, 2, 3, 4, 5, 6, 7, 8],
      usersPermitidos: ["corretor", "gerenteVendas", "superintendente"],
    },
    {
      id: 5,
      title: "Controle de visitas",
      redirecionamento: `https://crmcyr.cyrela.com.br/CRM/main.aspx?etc=10023&extraqs=?pagemode%3diframe%26sitemappath%3dSFA%257cSFA_Group_ForcaVendas%257cSFA_Group_ForcaVendas_ControleVisita&pagetype=entitylist&viewid=%7b${user?.idCorretor2013}%7d&viewtype=1039#278666811`,
      icone: <IconsSVG.ControleVisitasIcon style={{ marginTop: 10 }} />,
      iconTopRight: true,
      regionaisPermitidas: [2, 3, 6, 7],
      usersPermitidos: ["corretor", "gerenteVendas", "superintendente"],
    },
    {
      id: 6,
      title: "Oferta Ativa",
      redirecionamento: "/campanhas-criadas",
      icone: <IoVolumeHighOutline color="#2D5BFF" size={36} />,
      iconTopRight: false,
      regionaisPermitidas: [1, 2, 3, 4, 5, 6, 7, 8],
      usersPermitidos: ["corretor", "gerenteVendas", "superintendente"],
    },
    {
      id: 7,
      title: "Espelho de vendas",
      onClick: () => setOportunityModal(true),
      icone: <IconsSVG.ShortcutProductsIcon />,
      iconTopRight: true,
      regionaisPermitidas: [1, 2, 3, 4, 5, 6, 7, 8],
      usersPermitidos: ["corretor", "gerenteVendas", "superintendente"],
    },
    {
      id: 7,
      title: "Checkin",
      redirecionamento: "/checkin",
      icone: (
        <IconsSVG.ProductPredio2
          color="#2D5BFF"
          size="32"
          viewBox=" 0 0 14 15"
        />
      ),
      iconTopRight: false,
      regionaisPermitidas: [1, 2, 3, 4, 5, 6, 7, 8],
      usersPermitidos: ["corretor", "gerenteVendas", "superintendente"],
    },
    {
      id: 8,
      title: "Roleta",
      redirecionamento: "/roleta",
      icone: <IconsSVG.RoletaIcon />,
      iconTopRight: false,
      regionaisPermitidas: [1, 2, 3, 4, 5, 6, 7, 8],
      usersPermitidos: ["corretor"],
    },
  ];

  const regionalDoUsuario = Number(user?.codigoEmpresaVendas365).valueOf() || 0;
  const itensPermitidosPelaRegional = items.filter((item) => {
    return item.regionaisPermitidas.includes(regionalDoUsuario);
  });

  const newItemArr = itensPermitidosPelaRegional.filter((item) =>
    item.usersPermitidos.includes(cargoUser())
  );

  return (
    <>
      <Styles.Container>
        <Styles.BackgroundImage src={images.shortcutsbg} />
        <Styles.EffectContainer>
          <Styles.BackgroundEffect src={images.bulletsbg} />
        </Styles.EffectContainer>
        <Styles.Title>O que você gostaria de fazer?</Styles.Title>
        <Styles.ContainerSwipe>
          {/* @ts-ignore */}
          <Carousel
            renderPagination={renderCarouselPagination()}
            renderArrow={renderCarouselArrow()}
            isRTL={false}
            breakPoints={breakPoints}
          >
            {newItemArr.map((item) => (
              <Styles.ShortcutCard
                key={`${item.id}-${item.title}`}
                href={item?.redirecionamento || undefined}
                target={item?.iconTopRight ? "_blank" : ""}
                onClick={item?.onClick ? item?.onClick : undefined}
              >
                {item?.iconTopRight ? (
                  <Styles.BlankIcon>
                    <IconsSVG.ShortcutBlankIcon />
                  </Styles.BlankIcon>
                ) : null}
                {item.icone}
                <Styles.CardText>{item?.title}</Styles.CardText>
              </Styles.ShortcutCard>
            ))}
          </Carousel>
        </Styles.ContainerSwipe>
      </Styles.Container>
      <DialogCommon
        closeText=""
        saveText=""
        onClose={() => setOportunityModal(false)}
        onSave={() => {}}
        titleHeader="Qual bloco você gostaria de ver?"
        isRight={false}
        onClean={() => {}}
        isFilter={false}
        isClose
        width={600}
        marginBottom={54}
        component={<ModalEspelho idCorretor2013={idCorretor2013} />}
        setOpenModal={setOportunityModal}
        open={oportunityModal}
      />
    </>
  );
};

export default WantToDoCard;
